"use strict";
exports.__esModule = true;
exports.SvgHome = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgHome = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 24 24" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("path", { fill: "currentColor", fillRule: "nonzero", d: "M12.65 3.24l7.612 6.51c.464.38.733.949.733 1.549v8.697c0 .856-.126 1.001-1 1.001h-16c-.836 0-.981-.112-.994-.869L3 11.3a2 2 0 01.734-1.55l7.616-6.51a1 1 0 011.3 0zM12 4.657l-7.318 6.255a.497.497 0 00-.174.298l-.008.09v8.197h14.994v-8.198a.503.503 0 00-.132-.337l-.075-.072-7.288-6.233z" }),
        react_1["default"].createElement("path", { d: "M0 0h24v24H0z" })))); };
//# sourceMappingURL=Home.js.map